import Button from '@platform-ui-common/components/Button/index.js';
import { IconType } from '@platform-ui-common/components/Icon/Icon.types.js';
import Icon from '@platform-ui-common/components/Icon/index.js';
import Color from '@platform-ui-common/utilities/Color.js';

interface ButtonComponentProps {
  buttonText: string;
  route: string;
  icon: IconType;
  onClickClose?: () => void;
  disabled: boolean;
}

export default function ButtonComponent({
  onClickClose,
  buttonText,
  route,
  icon,
  disabled,
}: ButtonComponentProps): JSX.Element {
  return (
    <div className="flex gap-x-4 align-start md:w-[18rem]">
      <Icon color={Color.Text} type={icon} size="MD" />
      <Button
        onClick={onClickClose}
        type="button"
        variant="text"
        textColor={Color.Text}
        link={route}
        disabled={disabled}
      >
        <div className="text-left text-wrap leading-5 mt-[-3px]">{buttonText}</div>
      </Button>
    </div>
  );
}
